<template>
  <div class="bg-white px-4 py-4 rounded">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Información de Solicitud
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-2">
        <span class="data-title">Fecha de Solicitud:</span>
        <p>{{ item.requestDate | date }}</p>
      </div>
      <div class="col-12 col-lg-2">
        <span class="data-title">Número de Solicitud:</span>
        <p>{{ item.requestCode | empty }}</p>
      </div>
      <div class="col-12 col-lg-2">
        <span class="data-title">Sometido por:</span>
        <p>{{ item.requestBy | empty }}</p>
      </div>
      <div class="col-12 col-lg-6">
        <span class="data-title">Estatus:</span>
        <custom-balloon
          :background-color="item.statusColor"
          class="mt-2"
          :text="item.statusName"
          dot
        />
      </div>
      <div class="col-12 col-lg-4">
        <span class="data-title">Razon:</span>
        <p>{{ item.reason | empty }}</p>
      </div>
      <div class="col-12 col-lg">
        <span class="data-title">Comentario:</span>
        <p>{{ item.comment | empty }}</p>
      </div>
    </div>
    <div class="row mt-2" v-if="hasDocument">
      <div class="col-12">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-file mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Documento
          </div>
        </div>
      </div>
      <div class="col-12">
        <custom-callout
          class="my-3"
          :has-toggle="false"
          class-main="bg-gray-light"
        >
          <div class="row mt-2">
            <div class="col-12 col-lg-3">
              <div>
                <label
                  class="color-secondary-6 font-weight-normal mr-2 font-16"
                >
                  Tipo del Documento:
                </label>
              </div>
              <p>{{ item.documentType | empty }}</p>
            </div>
            <div class="col-12 col-lg-4">
              <div>
                <label
                  class="color-secondary-6 font-weight-normal mr-2 font-16"
                >
                  Nombre del Documento:
                </label>
              </div>
              <p>{{ item.documentTitle | empty }}</p>
            </div>
            <div class="col-12 col-lg">
              <div class="d-flex justify-content-lg-end mr-3">
                <action-button
                  class="btn-action-size ml-2 mt-3"
                  i="fas fa-file-download"
                  variant="success"
                  @click="downloadHandler"
                />
              </div>
            </div>
          </div>
        </custom-callout>
      </div>
    </div>
  </div>
</template>
<script>
import CustomBalloon from 'custom-balloon';
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import documentService from '@/services/api/document.api.js';
import inventoryService from '@/services/api/inventorycatalog.api';
import mixAlert from '@/mixins/alert.mixin';

export default {
  name: 'TransferRequestInfo',
  components: {
    CustomBalloon,
    CustomCallout,
    ActionButton,
  },
  mixins: [mixAlert],
  props: {
    transferId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    item: {},
  }),
  computed: {
    hasDocument() {
      return Boolean(this.item.documentId);
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const { data } = await inventoryService.getTransferInfo(this.transferId);
      this.item = data;
    },
    async downloadHandler() {
      await documentService
        .downloadFromServer(this.item.documentId)
        .catch(() => {
          this.ShowToast(
            'Error',
            'Hubo un error al descargar el documento',
            'error'
          );
        });
    },
  },
};
</script>
<style scoped>
.bg-gray-light {
  background: #f8f8f8 !important;
}
</style>
